import { TranslatePipe } from '../../../filters/translate.pipe';
import { ItemNotificationComponent } from '../../../components/item-notification/item-notification.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import ServiceRestServices from '../../../services/service-rest.service';
import Session from '../../../utils/session.service';
import Toast from '../../../services/toast.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularMaterialHelperService from '../../../services/angular-material-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';
import CalendarLocaleService from '../../../services/calendar-locale.service';
import $ from 'jquery';
import moment from 'moment';
import { UiCalendarService } from '../../../services/ui-calendar.service';
import { UiCalendarComponent } from '../../../components/ui-calendar/ui-calendar.component';

@Component({
	standalone: true,
	selector: 'schedule-configuration',
	templateUrl: './schedule-configuration.component.html',
	imports: [ CommonModule, TranslatePipe, ItemNotificationComponent, FormsModule, UiCalendarComponent ]
})
export default class ScheduleConfigurationView implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularMaterialHelperService: AngularMaterialHelperService = inject(AngularMaterialHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private calendarService: UiCalendarService = inject(UiCalendarService);
	private calendarLocaleService: CalendarLocaleService = inject(CalendarLocaleService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('schedule').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		this.angularMaterialHelperService.getMaterialToast().dismiss();
	}
	
	onResolve() {
		//this.angularMaterialHelperService.getMaterialThemingProvider().theme('error'); // Register toast theme

		this.vm.user = this.session.getSession().user;
		const calendarLocale = this.calendarLocaleService.getFullCalendarLocale(this.vm.user.deviceLanguage);
		!this.vm.user.businessUser ? this.angularRoutingHelperService.setPath('/') : null;
		this.vm.eventsFetched = false;
		this.vm.id = 1;
		this.vm.eventSources = [];
		this.vm.leadTimeInMinutes = 0;

		this.angularHelperService.createTimer(() => {
			this.toast.showAsync(
				this.angularFilterHelperService.translate('Calendar.Other.Selection_Tutorial'),
				this.angularFilterHelperService.translate('Common.Got_It'),
				10000);
		}, 500);

		this.vm.exclude = this.exclude;
		this.vm.redirect = this.redirect;

		this.serviceRestServices.getSchedule({
			startDate: moment().startOf('week').format('YYYYMMDD'),
			endDate: moment().startOf('week').add(6, 'd').format('YYYYMMDD')
		}, (schedule) => {
			this.angularHelperService.createTimer(() => {
				var calendarElement: any = $('#calendar');
				this.angularHelperService.getWindow().innerWidth <= 700
					? calendarElement.fullCalendar('changeView', 'agendaDay')
					: calendarElement.fullCalendar('changeView', 'agendaWeek');
			});

			if (this.vm.user.businessUser) {
				this.serviceRestServices.getServiceByUserId({ userId: this.vm.user.id },
					(service) => {
						this.vm.service = service;
						this.vm.leadTimeInMinutes = this.vm.service?.nextAvailableLeadTimeInMinutes || 0;
					},
					() => {
						// ignore
					}
				);
			}

			this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
				this.vm.eventSources.push({
					start: slot.startTime,
					end: slot.endTime,
					id: slot.id,
					recurring: slot.recurringType,
					textColor: '#fff',
					isVideoSupported: slot.isVideoSupported,
					isOnSiteSupported: slot.isOnSiteSupported
				});
			});

			this.vm.eventsFetched = true;
			this.vm.events = [this.vm.eventSources];

			this.vm.uiConfig = {
				calendarConf: {
					header: {
						left: 'title',
						center: '',
						right: 'today agendaWeek month prev,next'
					},
					allDaySlot: false,
					allDayDefault: false,
					eventTextColor: '#ffffff',
					height: 'auto',
					slotLabelFormat: 'H:mm',
					minTime: '00:00:00',
					maxTime: '24:00:00',
					timezone: 'local',
					firstDay: 1,
					defaultView: 'agendaWeek',
					timeFormat: 'H:mm',
					// slotDuration: '00:15:00',
					slotLabelInterval: '01:00:00',
					selectable: true,
					eventStartEditable: false,
					eventDurationEditable: false,
					displayEventEnd: true,
					selectOverlap: false,
					eventOverlap: false,
					nowIndicator: false,
					views: {
						agenda: {
							columnFormat: 'DD.MM dddd'
						},
						month: {
							columnFormat: 'dddd',
							selectable: true,
							eventLimit: 4,
							eventLimitClick: 'agendaWeek'
						}
					},
					dayClick: (date, allDay, jsEvent, view) => {
						if (this.angularHelperService.getWindow().innerWidth > 700) {
							var calendarElement: any = $('#calendar');
							calendarElement.fullCalendar('changeView', 'agendaWeek');
							calendarElement.fullCalendar('gotoDate', date);
						}
					},
					viewRender: (view, element) => {
						var calendarElement: any = $('#calendar');
						this.togglePrevButton(view);
						calendarElement.fullCalendar('removeEvents');
						this.vm.eventSources = [];
						view.type !== 'month' ? $('.fc-left').css('display', 'none') : $('.fc-left').css('display', 'block');
						this.serviceRestServices.getSchedule({
							startDate: moment(view.start).format('YYYYMMDD'),
							endDate: moment(view.end).format('YYYYMMDD')
						}, (schedule) => {
							if (view.type !== 'month') {
								this.angularHelperService.forEach(this.angularHelperService.element('.fc-day-header'), (value, key) => {
									var date: any = moment(value.attributes['data-date'].value).format('YYYYMMDD');
									if (value.childNodes.length < 2) {
										this.appendDisableButton(value, date);
									}
								});
							}

							this.vm.excluded = schedule.excludeDates;
							if (schedule.excludeDates && schedule.excludeDates.length > 0 && view.type !== 'month') {
								this.angularHelperService.forEach(schedule.excludeDates, (excluded) => {
									this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
										moment(slot.startTime).isSame(excluded.excludeDate, 'day') ? slot.isExcluded = true : null;

									});
									this.angularHelperService.forEach(this.angularHelperService.element('.fc-day-header'), (value, key) => {
										var date: any = moment(value.attributes['data-date'].value).format('YYYYMMDD');
										if (moment(date).isSame(excluded.excludeDate, 'day')) {
											this.angularHelperService.element(value).addClass('fc-disabled-day');
											this.appendEnableButton(value, date);
										}
									});
									this.angularHelperService.forEach(this.angularHelperService.element('.fc-day'), (value, key) => {
										var date: any = moment(value.attributes['data-date'].value).format('YYYYMMDD');
										if (moment(date).isSame(excluded.excludeDate, 'day')) {
											this.angularHelperService.element(value).addClass('fc-disabled-day');
										}
									});
								});

								this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
									if (!slot.isExcluded) {
										this.vm.eventSources.push({
											start: slot.startTime,
											end: slot.endTime,
											id: slot.id,
											recurring: slot.recurringType,
											textColor: '#fff',
											isVideoSupported: slot.isVideoSupported,
											isOnSiteSupported: slot.isOnSiteSupported
										});
									} else {
										this.vm.eventSources.push({
											start: slot.startTime,
											end: slot.endTime,
											id: slot.id,
											recurring: slot.recurringType,
											textColor: '#fff',
											backgroundColor: '#a52a2a',
											excluded: true,
											isVideoSupported: slot.isVideoSupported,
											isOnSiteSupported: slot.isOnSiteSupported
										});
									}
								});
							}

							if (!schedule.excludeDates || view.type === 'month') {
								this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
									this.vm.eventSources.push({
										start: slot.startTime,
										end: slot.endTime,
										id: slot.id,
										recurring: slot.recurringType,
										isVideoSupported: slot.isVideoSupported,
										isOnSiteSupported: slot.isOnSiteSupported
									});
								});
							}

							if (view.type === 'agendaDay') {
								var seen: any = {};
								this.vm.eventSources = this.vm.eventSources.filter((entry) => {
									if (seen.hasOwnProperty(entry.id)) {
										return false;
									}
									seen[entry.id] = entry;
									return true;
								});
								var calendarElement2: any = $('#calendar');
								calendarElement2.fullCalendar('removeEvents');
								calendarElement2.fullCalendar('refetchEvents');

							}

							const pastOverlay = this.buildPastOverlay(moment(view.start), moment(view.end));

							if (pastOverlay) {
								this.vm.eventSources.push(pastOverlay);
							}

							if (this.vm.leadTimeInMinutes > 0) {
								const delayOverlay = this.buildDelayOverlay(moment(view.end));
								if (delayOverlay) {
									this.vm.eventSources.push(delayOverlay);
								}
							}

							this.calendarService.getById('scheduleCalendarConf').fullCalendar('addEventSource', this.vm.eventSources);
							this.calendarService.getById('scheduleCalendarConf').fullCalendar('rerenderEvents');

							this.vm.eventsFetched = true
						}, () => {
							// ignore
						});
					},
					windowResize: (view) => {
						var calendarElement: any = $('#calendar');
						this.vm.width = this.angularHelperService.getWindow().innerWidth;
						this.vm.width <= 700
							? calendarElement.fullCalendar('changeView', 'agendaDay')
							: view.type !== 'agendaDay'
								? calendarElement.fullCalendar('changeView', view.type)
								: calendarElement.fullCalendar('changeView', 'agendaWeek');
					},
					eventRender: (event, element) => {
						var calendarElement: any = $('#calendar');
						if (calendarElement.fullCalendar('getView').type !== 'month' && !event.excluded && !event.isPast && !event.isDelay) {
							let videoColor = 'rgba(208,203,203,0.46)';
							let homeColor = 'rgba(208,203,203,0.46)';
							let videoCursor = 'pointer';
							let homeCursor = 'pointer';
							const type = this.vm.service?.typeOfAppointment;

							if (type === 'VIDEO_SESSION_ONLY') {
								videoColor = '#fff';
								homeColor = 'rgba(208,203,203,0.46)';
								homeCursor = 'default';
							} else if (type === 'FACE_TO_FACE_SESSION_ONLY') {
								homeColor = '#fff';
								videoColor = 'rgba(208,203,203,0.46)';
								videoCursor = 'default';
							} else if (type === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
								if (event.isVideoSupported) videoColor = '#fff';
								if (event.isOnSiteSupported) homeColor = '#fff';
							}

							const rightControls = `
							<div class="timeslot-controls" style="float: right; display: flex; align-items: center; gap: 12px;">
							  <span class="timeslot-icons" style="display: flex; align-items: center; gap: 8px;">
								<i class="o-icon o-icon--video video-icon" 
								   title="Video session"
								   style="color: ${videoColor} !important; cursor: ${videoCursor};"></i>
								<i class="o-icon o-icon--home home-icon" 
								   title="Face-to-face session"
								   style="color: ${homeColor} !important; cursor: ${homeCursor};"></i>
							  </span>
							  <span class="closeon" data-event-id="${event.id}" style="cursor: pointer;">&#10005;</span>
							</div>`;

							element.prepend(rightControls);

							element.find('.closeon').on('click', (elem) => {

								event.recurring !== 'ONCE' ?
									this.serviceRestServices.timeslotDeadline({ id: event.id, deadlineDate: event.start }, (response) => {}) :
									this.serviceRestServices.updateSchedule({
										removed: [{ id: event.id }]
									}, (response) => {
										this.showErrorToasts(response);
									});
								calendarElement.fullCalendar('removeEvents', event.id);
							});

						if (this.vm.service && (this.vm.service.typeOfAppointment === 'VIDEO_AND_FACE_TO_FACE_SESSIONS'
								|| this.vm.service.typeOfAppointment === 'FACE_TO_FACE_SESSION_ONLY'
								|| this.vm.service.typeOfAppointment === 'VIDEO_SESSION_ONLY')) {
							const icons = element.find('.timeslot-icons');
							const videoIcon = icons.find('.video-icon');
							const homeIcon = icons.find('.home-icon');

							let isVideo = !!event.isVideoSupported;
							let isHome = !!event.isOnSiteSupported;

							videoIcon.css('color', isVideo ? '#fff' : 'rgba(208,203,203,0.46)');
							homeIcon.css('color', isHome ? '#fff' : 'rgba(208,203,203,0.46)');

							videoIcon.on('click', () => {
									if (this.vm.service?.typeOfAppointment === 'FACE_TO_FACE_SESSION_ONLY') {
										this.toast.showAsync(this.angularFilterHelperService.translate('Calendar.Other.Activate_Video_Option_Message'));
										return;
									}

									isVideo = !isVideo;

									if (!isVideo && !isHome) {
										isVideo = true;
									}

									event.isVideoSupported = isVideo;
									event.isOnSiteSupported = isHome;

									videoIcon.css('color', isVideo ? '#fff' : 'rgba(208,203,203,0.46)');
									homeIcon.css('color', isHome ? '#fff' : 'rgba(208,203,203,0.46)');

									this.serviceRestServices.updateSchedule({
										removed: [{ id: event.id }],
										added: [{
											isVideoSupported: isVideo,
											isOnSiteSupported: isHome,
											recurringType: event.recurring,
											startTime: moment(event.start),
											endTime: moment(event.end)
										}]
									}, (response) => {
										if (!!response.removed) {
											response.removed.forEach((removedEvent) => {
												calendarElement.fullCalendar('removeEvents', removedEvent.id);
											});
										}
										this.updateAddedTimeSlots(calendarElement, response.added);
										this.calendarService.getById('scheduleCalendarConf').fullCalendar('renderEvents');
									});
								});

                            homeIcon.on('click', () => {

									if (this.vm.service?.typeOfAppointment === 'VIDEO_SESSION_ONLY') {
										this.toast.showAsync(this.angularFilterHelperService.translate('Calendar.Other.Activate_Face_To_Face_Option_Message'));
										return;
									}

									isHome = !isHome;

									if (!isHome && !isVideo) {
										isHome = true;
									}

									event.isVideoSupported = isVideo;
									event.isOnSiteSupported = isHome;

									videoIcon.css('color', isVideo ? '#fff' : 'rgba(208,203,203,0.46)');
									homeIcon.css('color', isHome ? '#fff' : 'rgba(208,203,203,0.46)');

									this.serviceRestServices.updateSchedule({
										removed: [{ id: event.id }],
										added: [{
											isVideoSupported: isVideo,
											isOnSiteSupported: isHome,
											recurringType: event.recurring,
											startTime: moment(event.start),
											endTime: moment(event.end)
										}]
									}, (response) => {
										if (!!response.removed) {
											response.removed.forEach((removedEvent) => {
												calendarElement.fullCalendar('removeEvents', removedEvent.id);
											});
										}
										this.updateAddedTimeSlots(calendarElement, response.added);
										this.calendarService.getById('scheduleCalendarConf').fullCalendar('renderEvents');
									});
								});
							}
							element.children('.fc-content').append(
								'<select class="fc-recurring">' +
								'<option value="ONCE">' + this.angularFilterHelperService.translate('Calendar.Interval.Once') + '</option>' +
								'<option value="WEEKLY">' + this.angularFilterHelperService.translate('Calendar.Interval.Weekly') + '</option>' +
								'<option value="MONTHLY">' + this.angularFilterHelperService.translate('Calendar.Interval.Monthly') + '</option>' +
								'</select>'
							);
							element.children('.fc-content').children('.fc-recurring').attr('data-event-id', event.id);

							element.find('select').val(event.recurring || 'WEEKLY');
							element.find('select').on('change', (elem) => {
								element.children('.fc-content').children('.fc-recurring').val(elem.target.value);
								calendarElement.fullCalendar('removeEvents', event.id);

								element.find('select').val(elem.target.value);
								event.recurring = elem.target.value;

								this.serviceRestServices.updateSchedule({
									removed: [{ id: event.id }],
									added: [{
										recurringType: event.recurring,
										startTime: moment(event.start),
										endTime: moment(event.end),
										isVideoSupported: true,
										isOnSiteSupported: false,
									}]
								}, (response) => {
									var added = response.added;
									this.showErrorToasts(response);
									this.updateAddedTimeSlots(calendarElement, added);
								});
							});
						}
					},
					eventClick: (event) => {
						if (event.isDelay) {
							this.toast.showAsync(this.angularFilterHelperService.translate('Calendar.Other.Delay_Time_Slot_Info'), this.angularFilterHelperService.translate('Common.Got_It'), 10000);
						}
					},
					select: (startDate, endDate) => {
						var isSelectable: any = this.vm.excluded ? this.vm.excluded.every((date) => {
							return !moment(date.excludeDate).isSame(startDate, 'day');
						}) : true;

						var calendarElement: any = $('#calendar');
						if (isSelectable && calendarElement.fullCalendar('getView').type !== 'month') {
							// Init
							// Get durations
							var durations: any = {};
							durations.service = ((this.vm.service || {}).pricing || {}).timePerPrice || 0;
							const diffInMinutes = moment(endDate).diff(moment(startDate)) / 1000 / 60;
							durations.selection = diffInMinutes;
							// Show error notification if usual service time is longer than selections
							// And do not add selection to schedule
							if (durations.service > durations.selection) {
								// Show toast
								var message = this.angularFilterHelperService.stringBuilder(
									this.angularFilterHelperService.translate('Calendar.Other.Selection_Short'), durations.service);
								this.toast.showAsync(message, null, null, 'error');
								// Remove highlight
								calendarElement.fullCalendar('unselect');
								return;
							}

							const type = this.vm.service?.typeOfAppointment;
							let isVideoSupported = false;
							let isOnSiteSupported = false;

							if (type === 'VIDEO_SESSION_ONLY') {
								isVideoSupported = true;
							} else if (type === 'FACE_TO_FACE_SESSION_ONLY') {
								isOnSiteSupported = true;
							} else if (type === 'VIDEO_AND_FACE_TO_FACE_SESSIONS') {
								isVideoSupported = true;
							}

							// If no errors, then update
							// Update schedule
							this.vm.added = {
								recurringType: 'ONCE',
								startTime: moment(startDate),
								endTime: moment(endDate),
								isVideoSupported,
								isOnSiteSupported
							};

							this.serviceRestServices.updateSchedule({
								added: [this.vm.added]
							}, (response) => {
								var added = response.added;
								this.showErrorToasts(response);
								this.updateAddedTimeSlots(calendarElement, added);
							});
						} else {
							calendarElement.fullCalendar('unselect');
						}
					}

				}
			};
			Object.assign(this.vm.uiConfig.calendarConf, calendarLocale);

			this.vm.scheduleLoaded = true;

		}, (error) => {
			// ignore
		});
	}

	buildPastOverlay(viewStart: moment.Moment, viewEnd: moment.Moment) {
		const now = moment();

		if (viewEnd.isSameOrBefore(now)) {
			return {
				start: viewStart,
				end: viewEnd,
				rendering: 'background',
				backgroundColor: '#e0e0e0',
				overlap: false,
				isPast: true
			};
		}

		if (viewStart.isAfter(now)) {
			return null;
		}

		return {
			start: viewStart,
			end: moment.min(now, viewEnd),
			rendering: 'background',
			backgroundColor: '#e0e0e0',
			overlap: false,
			isPast: true
		};
	}


	buildDelayOverlay(viewEnd: moment.Moment) {
		const now = moment();
		const delayEnd = moment().add(this.vm.leadTimeInMinutes, 'minutes');

		if (now.isAfter(viewEnd)) {
			return null;
		}

		return {
			start: now,
			end: moment.min(delayEnd, viewEnd),
			overlap: false,
			backgroundColor: '#ffe0b2',
			textColor: '#000',
			isDelay: true
		};
	}

	togglePrevButton(view) {
		const now = moment();
		const prevButton = $('.fc-prev-button');
		if (moment(view.start).isSameOrBefore(now)) {
			prevButton.hide();
		} else {
			prevButton.show();
		}
	}

	showErrorToasts(response) {
		if (response.failed) {
			for (var f = 0; f < response.failed.length; f++) {
				if (response.failed[f].error) {
					var err = response.failed[f].error;
					this.toast.showInParent(err.model + '.' + err.property + '.' + err.message);
				}
			}
		}
	}
	
	updateAddedTimeSlots(calendarElement, added) {
		if (added) {			
			for (var a = 0; a < added.length; a++) {									
				var slot: any = added[a];
				var newEvent: any = {
					start: slot.startTime,
					end: slot.endTime,
					id: slot.id,
					recurring: slot.recurringType,
					textColor: '#fff',
					isVideoSupported: slot.isVideoSupported ?? false,
					isOnSiteSupported: slot.isOnSiteSupported ?? false
				};
				calendarElement.fullCalendar('renderEvent', newEvent);
			}
		}
	}
	
	exclude(enable, date) {
		var calendarElement: any = $('#calendar');
		var currentView: any = calendarElement.fullCalendar('getView');
		if (!enable) {
			this.serviceRestServices.excludeScheduleDate({ excludeDate: date }, {}, (schedule) => {
				this.serviceRestServices.getSchedule({
					startDate: moment(currentView.start).format('YYYYMMDD'),
					endDate: moment(currentView.start).add(6, 'd').format('YYYYMMDD')
				}, (schedule) => {
					this.vm.excluded = schedule.excludeDates;
					
					this.angularHelperService.forEach(this.angularHelperService.element('.fc-day-header'), (value, key) => {
						var dataDate: any = moment(value.attributes['data-date'].value);
						if (moment(String(dataDate)).isSame(String(date), 'day')) {
							this.angularHelperService.element(value).addClass('fc-disabled-day');
							this.replaceEnableButton(value, date);
						}
					});
					this.angularHelperService.forEach(this.angularHelperService.element('.fc-day'), (value, key) => {
						var dataDate: any = moment(value.attributes['data-date'].value);
						if (moment(String(dataDate)).isSame(String(date), 'day')) {
							this.angularHelperService.element(value).addClass('fc-disabled-day');
						}
					});
					
					var calendarElement3: any = $('#calendar');
					calendarElement3.fullCalendar('removeEvents');
					this.vm.eventSources = [];
					
					this.angularHelperService.forEach(schedule.excludeDates, (excluded) => {
						this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
							moment(slot.startTime).isSame(excluded.excludeDate, 'day') ? slot.isExcluded = true : null;
							
						});
					});
					
					this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
						if (!slot.isExcluded) {
							this.vm.eventSources.push({
								start: slot.startTime,
								end: slot.endTime,
								id: slot.id,
								recurring: slot.recurringType,
								textColor: '#fff',
								isVideoSupported: slot.isVideoSupported,
								isOnSiteSupported: slot.isOnSiteSupported
							});
						} else {
							this.vm.eventSources.push({
								start: slot.startTime,
								end: slot.endTime,
								id: slot.id,
								recurring: slot.recurringType,
								textColor: '#fff',
								backgroundColor: '#a52a2a',
								excluded: true,
								isVideoSupported: slot.isVideoSupported,
								isOnSiteSupported: slot.isOnSiteSupported
							});
						}
					});
					
					this.calendarService.getById('scheduleCalendarConf').fullCalendar('addEventSource', this.vm.eventSources);
				});
			});
		}
		if (enable) {
			this.serviceRestServices.includeScheduleDate({ excludeDate: date }, (schedule) => {
				this.serviceRestServices.getSchedule({
					startDate: moment(currentView.start).format('YYYYMMDD'),
					endDate: moment(currentView.start).add(6, 'd').format('YYYYMMDD')
				}, (schedule) => {
					
					this.vm.excluded = schedule.excludeDates;
					
					this.angularHelperService.forEach(this.angularHelperService.element('.fc-day-header'), (value, key) => {
						var dataDate: any = moment(value.attributes['data-date'].value);
						if (moment(String(dataDate)).isSame(String(date), 'day')) {
							this.angularHelperService.element(value).removeClass('fc-disabled-day');
							this.replaceDisableButton(value, date);
						}
					});
					this.angularHelperService.forEach(this.angularHelperService.element('.fc-day'), (value, key) => {
						var dataDate: any = moment(value.attributes['data-date'].value);
						if (moment(String(dataDate)).isSame(String(date), 'day')) {
							this.angularHelperService.element(value).removeClass('fc-disabled-day');
						}
					});
					
					var calendarElement4: any = $('#calendar');
					calendarElement4.fullCalendar('removeEvents');
					this.vm.eventSources = [];
					
					this.angularHelperService.forEach(schedule.excludeDates, (excluded) => {
						this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
							moment(slot.startTime).isSame(excluded.excludeDate, 'day') ? slot.isExcluded = true : null;
							
						});
					});
					
					this.angularHelperService.forEach(schedule.timeSlots, (slot) => {
						if (!slot.isExcluded) {
							this.vm.eventSources.push({
								start: slot.startTime,
								end: slot.endTime,
								id: slot.id,
								recurring: slot.recurringType,
								textColor: '#fff',
								isVideoSupported: slot.isVideoSupported,
								isOnSiteSupported: slot.isOnSiteSupported
							});
						} else {
							this.vm.eventSources.push({
								start: slot.startTime,
								end: slot.endTime,
								id: slot.id,
								recurring: slot.recurringType,
								textColor: '#fff',
								backgroundColor: '#a52a2a',
								excluded: true,
								isVideoSupported: slot.isVideoSupported,
								isOnSiteSupported: slot.isOnSiteSupported
							});
						}
					});
					
					this.calendarService.getById('scheduleCalendarConf').fullCalendar('addEventSource', this.vm.eventSources);
					
				});
			});
		}
	}
	
	appendDisableButton(targetEl: any, date: string) {
		const buttonHtml =
			`<div class='configure-action-button'><button class='disable-day' data-date='` + date + `'>`
			+ this.angularFilterHelperService.translate('Calendar.Button.Disable_Day')
			+ `</button></div>`;

		$(targetEl).append(buttonHtml);

		$(targetEl).find('.disable-day').last().on('click', () => {
			this.vm.exclude(false, date);
		});
	}
	
	replaceDisableButton(targetEl: any, date: string) {
		const buttonHtml =
			`<div class='configure-action-button'><button class='disable-day'>`
			+ this.angularFilterHelperService.translate('Calendar.Button.Disable_Day')
			+ `</button></div>`;

		$(targetEl).find('div').replaceWith(buttonHtml);

		$(targetEl).find('.disable-day').last().on('click', () => {
			this.vm.exclude(false, date);
		});
	}
	
	appendEnableButton(targetEl: any, date: string) {
		const buttonHtml =
			`<div class='configure-action-button'><button class='enable-day' data-date='` + date + `'>`
			+ this.angularFilterHelperService.translate('Calendar.Button.Enable_Day')
			+ `</button></div>`;

		$(targetEl).find('div').replaceWith(buttonHtml);

		$(targetEl).find('.enable-day').last().on('click', () => {
			this.vm.exclude(true, date);
		});
	}

	replaceEnableButton(targetEl: any, date: string) {
		const buttonHtml =
			`<div class='configure-action-button'><button class='enable-day'>`
			+ this.angularFilterHelperService.translate('Calendar.Button.Enable_Day')
			+ `</button></div>`;

		$(targetEl).find('div').replaceWith(buttonHtml);

		$(targetEl).find('.enable-day').last().on('click', () => {
			this.vm.exclude(true, date);
		});
	}
	
	redirect(path) {
		this.angularRoutingHelperService.setPath(path);
	}
	
}
